import filterTypes from './dataTableFilterTypes';

export default {

    compareValue(item, searchValue, filter) {

        if (searchValue == null || searchValue.toString() == '')
            return true;

        var compareType = filter.compareType;
        if (!compareType)
            compareType = filterTypes.equal;

        var firstValue = item;
        var secondValue = searchValue;

        if (compareType == filterTypes.equal || compareType == filterTypes.notEqual) {
            firstValue = item != null ? item.toString() : '';
            secondValue = searchValue != null ? searchValue.toString() : '';

            if (!filter.matchCase) {
                firstValue = firstValue.toLowerCase();
                secondValue = secondValue.toLowerCase();
            }

            if (compareType == filterTypes.equal) {
                if (filter.matchWhole)
                    return firstValue == secondValue;
                return firstValue.includes(secondValue);
            }
            else if (compareType == filterTypes.notEqual) {
                if (filter.matchWhole)
                    return firstValue != secondValue;
                return !firstValue.includes(secondValue);
            }
        }

        switch (compareType) {

            case filterTypes.greaterThan:
                return firstValue > secondValue;

            case filterTypes.greaterOrEqualThan:
                return firstValue >= secondValue;

            case filterTypes.lessThan:
                return firstValue < secondValue;

            case filterTypes.lessOrEqualThan:
                return firstValue <= secondValue;

            default:
                throw 'invalid filter compareType';

        }

    },

    compareValues(item, searchValues, filter) {

        for (var i = 0; i < searchValues.length; i++) {
            var searchValue = searchValues[i];
            var isValid = this.compareValue(item, searchValue, filter);
            // in case on of the conditions is valid, we just return true
            if (isValid)
                return true;
        };

        return false;

    },

    getIndexByColumn(column, columns) {

        return columns.findIndex((c) => {
            return column == c;
        });

    },

    getColumnDefinitionByName(columns, column) {

        return columns.find((c) => {
            return c.name == column;
        })

    },

    getColumnDefinitionByIndex(columnsDefinition, columns, index) {

        var columnName = columns[index];
        return this.getColumnDefinitionByName(columnsDefinition, columnName)

    },

    filter(filter, data, columns) {

        if (filter.column == '*')
            return this.filterByAllColumns(filter, data, columns);

        return this.filterByColumn(filter, data, columns);

    },

    // filters data by column and value
    filterByColumn(filter, data, columns) {

        let values = filter.values;
        let column = filter.column;

        var columnIndex = this.getIndexByColumn(column, data.columns);

        var filteredRows = data.rows.filter((c) => {

            var item = c[columnIndex];

            // in case the filter is not by value, than we filter by the calculated action
            if (!filter.byValue) {

                // gets the column definision
                var column = this.getColumnDefinitionByName(columns, filter.column);

                // gets the "real" value of the column, if it owns a calculated action
                if (column && column.action)
                    item = column.action(item);
            }

            return this.compareValues(item, values, filter);

        });

        return {
            columns: data.columns,
            rows: filteredRows
        }

    },

    // filters data by value
    filterByAllColumns(filter, data, columns) {

        let values = filter.values;

        var filteredRows = data.rows.filter((row) => {

            var result = row.find((item, columnIndex) => {

                // in case the filter is not by value, than we filter by the calculated action
                if (!filter.byValue) {

                    // gets the column definision
                    var column = this.getColumnDefinitionByIndex(columns, data.columns, columnIndex);

                    // gets the "real" value of the column, if it owns a calculated action
                    if (column && column.action)
                        item = column.action(item);
                }

                return this.compareValues(item, values, filter);

            });

            if (result)
                return true;

            return false;

        });

        return {
            columns: data.columns,
            rows: filteredRows
        }

    }

}



// WEBPACK FOOTER //
// ./src/components/Common/DataTable/dataTableFilter.js